import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal} from "react-bootstrap";
import BackEnd from "../../../../backend/BackEnd";
import {successToast} from "../../../../utils/toasts";
import Dropdown from "../../../../controls/Dropdown";
import Fieldset from "../../../../utils/components/Fieldset";
import {required, validate} from "../../../../utils/validation";

class CreateRoleModal extends Component {
    static propTypes = {
        show: PropTypes.bool.isRequired,
        onSave: PropTypes.func.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        name: '',
        typeId: '',
        formState: {}
    };
    formMetadata = {
        name: [required('Введите название')],
        typeId: [required('Выберите стереотип')]
    };

    async componentWillReceiveProps({show}) {
        if (!show) return;

        this.setState({name: '', typeId: ''});
    }

    render() {
        const {onSave, ...props} = this.props;
        return (
            <Modal {...props} bsSize="small">
                <Modal.Header closeButton>
                    <Modal.Title>Новая роль</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="p-x-1">
                            <Fieldset formState={this.state.formState} fieldName="name">
                                <label className="control-label required"
                                       htmlFor="roleName">Название</label>
                                <input type="text" className="form-control"
                                       id="roleName" name="roleName"
                                       value={this.state.name}
                                       onChange={event => this.setState({name: event.target.value})}/>
                            </Fieldset>
                            <Fieldset formState={this.state.formState} fieldName="typeId">
                                <label className="control-label required"
                                       htmlFor="roleType">Стереотип</label>
                                <Dropdown dataSource={new BackEnd.Roles.SearchTypes()}
                                          className="form-control"
                                          id="roleType" name="roleType"
                                          value={this.state.typeId}
                                          onChange={event => this.setState({typeId: event.target.value})}/>
                            </Fieldset>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-primary"
                            onClick={() => this.createRole()}>
                        Создать
                    </button>
                    <button type="button" className="btn btn-default"
                            onClick={this.props.onHide}>
                        Закрыть
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    async createRole() {
        const {name, typeId} = this.state;

        const {isValid, ...formState} = validate(this.state, this.formMetadata);
        if (!isValid)
            return this.setState({formState});

        const createRole = new BackEnd.Roles.CreateRole(this);
        const result = await createRole.call({
            dto: {name, typeId}
        });

        if (result.success) {
            successToast(`Роль "${this.state.name}" успешно создана`);
            this.props.onSave();
            this.props.onHide();
        }
    }
}

export default CreateRoleModal;


// WEBPACK FOOTER //
// ./src/pages/System/Permissions/modals/CreateRoleModal.js